module.exports = __webpack_public_path__ + "assets/HKNova-Bold.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Bold.svg
// module id = 146
// module chunks = 0